// extracted by mini-css-extract-plugin
export var copyableField = "_ri-4";
export var customerBadge = "_ri-0";
export var customerInfoTitle = "_ri-2";
export var details = "_ri-1";
export var dropdownContainer = "_ri-5";
export var dropdownImage = "_ri-6";
export var editAssigneeForm = "_ri-a";
export var editButton = "_ri-3";
export var email = "_ri-7";
export var hidden = "_ri-d";
export var input = "_ri-8";
export var saveButton = "_ri-b";
export var shopifyIcon = "_ri-c";
export var suggestionBadge = "_ri-e";
export var suggestionText = "_ri-f";
export var username = "_ri-9";